import React from "react";
import { Field, connect } from "formik";

import { useTranslation } from "react-i18next";

import { ElementWrap, HelperText, ErrorContainer } from "../Scaffolding";

function CheckboxField(props) {
  const { t, i18n } = useTranslation();
  const {
    label,
    name,
    value,
    terms = false,
    helperText = "",
    className = "",
    ...rest
  } = props;

  return (
    <ElementWrap className={className} name={name}>
      <Field
        className={`checkbox ${className}`}
        name={name}
        type="checkbox"
        value={props.formik.values[name]}
        {...rest}
      />
      <label className={`form-element-label ${className}`} htmlFor={name}>
        {label || name}{" "}
        { terms ? <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://collect.plastx.co/policies"
        >
          {t("termsAndConditions")}
        </a> : "" }
      </label>
      <HelperText text={helperText} />
      <ErrorContainer name={name} />
    </ElementWrap>
  );
}

export default connect(CheckboxField);
